import React from 'react';
import { graphql } from 'gatsby';
import { FeaturedNews } from '../components/news/featured-news';
import { Grid } from '../components/grid';
import { Layout } from '../components/layout';
import { NewsCard } from '../components/news/news-card';
import { Seo } from '../components/seo';
import { Spacer } from '../components/spacer';

export const query = graphql`
  {
    allContentfulBlogPost(sort: { publishedOn: DESC }) {
      edges {
        node {
          id
          fields {
            readingTime
          }
          authors {
            name
          }
          publishedOn
          title
          publicTags {
            name
          }
          url
          leadImage {
            file {
              url
              fileName
              details {
                image {
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const Head = () => (
  <>
    <Seo lang="en" title="News" image="" />
  </>
);

const Index = ({ data }) => {
  const featuredNewsPost = data.allContentfulBlogPost.edges.find(
    ({ node: post }) =>
      post.publicTags &&
      post.publicTags.some((tag) => tag.name === 'Latest News'),
  ).node;

  const newsPosts = data.allContentfulBlogPost.edges.filter(
    ({ node: post }) => post.id !== featuredNewsPost.id,
  );

  return (
    <>
      <Layout>
        <FeaturedNews data={featuredNewsPost} />
        <Spacer height={3} />
        <Grid columns="3">
          {newsPosts.map(({ node: post }, id) => {
            return <NewsCard data={post} key={id} />;
          })}
        </Grid>
      </Layout>
    </>
  );
};

export default Index;
